import { StyleSheet } from 'react-native';
import { Colors } from './Colors';

/**
 * Centralised stylesheet for the VotesNow app.
 * Add or update styles here to keep UI consistent across screens.
 */
const AppStyles = StyleSheet.create({
  // Layout
  container: {
    flex: 1,
    backgroundColor: Colors.light.background,
  },
  centeredContainer: {
    flex: 1,
    alignItems: 'center',
    justifyContent: 'center',
    padding: 20,
    width: '100%',
  },
  // Typography
  titleText: {
    fontSize: 28,
    fontWeight: 'bold',
    textAlign: 'center',
    marginBottom: 30,
    marginTop: 20,
  },
  subtitleText: {
    fontSize: 20,
    fontWeight: '600',
    marginBottom: 20,
    textAlign: 'center',
  },
  normalText: {
    fontSize: 16,
    marginBottom: 16,
    textAlign: 'center',
  },
  errorText: {
    color: 'red',
    textAlign: 'center',
    marginTop: 20,
  },
  // Buttons
  primaryButton: {
    backgroundColor: '#007AFF',
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
    height: 40,
    paddingHorizontal: 16,
  },
  primaryButtonText: {
    color: '#fff',
    fontWeight: 'bold',
    fontSize: 16,
  },
  secondaryButton: {
    backgroundColor: '#6c757d',
    borderRadius: 8,
    alignItems: 'center',
    justifyContent: 'center',
    height: 40,
    paddingHorizontal: 16,
  },
  secondaryButtonText: {
    color: '#fff',
    fontWeight: 'bold',
    fontSize: 16,
  },
  linkButton: {
    flexDirection: 'row',
    backgroundColor: 'transparent',
    borderRadius: 8,
    borderWidth: 1,
    borderColor: '#007AFF',
    alignItems: 'center',
    justifyContent: 'center',
    height: 40,
    paddingHorizontal: 8,
  },
  linkButtonText: {
    fontSize: 16,
    fontWeight: '500',
    marginRight: 4,
  },
  // Inputs
  textInput: {
    borderWidth: 1,
    borderColor: '#ccc',
    borderRadius: 5,
    padding: 8,
    fontSize: 16,
    backgroundColor: '#fff',
    height: 40,
    width: '100%',
  },
  pickerWrapper: {
    borderWidth: 1,
    borderColor: '#ccc',
    borderRadius: 5,
    backgroundColor: '#fff',
    height: 40,
    justifyContent: 'center',
  },
  pickerInput: {
    height: 56,
    fontSize: 16,
    width: '100%',
    borderWidth: 0,
    backgroundColor: 'transparent',
  },
  // Address Card
  addressCard: {
    margin: 6,
    backgroundColor: '#f9f9f9',
    borderRadius: 6,
    padding: 12,
    elevation: 2,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.22,
    shadowRadius: 2.22,
  },
  addressHeader: {
    fontSize: 16,
    fontWeight: 'bold',
    marginBottom: 10,
    paddingBottom: 5,
    borderBottomWidth: 1,
    borderBottomColor: '#eee',
    flex: 1,
    flexWrap: 'wrap',
  },
  // Voter Item
  voterRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    paddingVertical: 6,
    borderBottomWidth: 1,
    borderBottomColor: '#f0f0f0',
  },
  voterName: {
    fontSize: 14,
  },
  voterVi: {
    fontSize: 14,
    color: '#3498db',
    fontWeight: '500',
  },

  viDropdownItemLabel: {
    fontSize: 14,
    color: '#007AFF',
  },
  dropdownDivider: {
    height: 1,
    backgroundColor: '#e0e0e0',
    marginTop: 12,
  },
  issuesInput: {
    borderWidth: 1,
    borderColor: '#ddd',
    borderRadius: 8,
    padding: 8,
    fontSize: 14,
    backgroundColor: '#ffffff',
    minWidth: 80,
    marginTop: 6,
    height: 36,
    textAlignVertical: 'top',
  },
  issuesInputFocused: {
    borderColor: '#007AFF',
    backgroundColor: '#fff',
    shadowColor: '#007AFF',
    shadowOffset: { width: 0, height: 0 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 2,
  },
  // Filter Controls
  filterGroup: {
    backgroundColor: '#f9f9f9',
    margin: 10,
    borderRadius: 8,
    borderWidth: 1,
    borderColor: '#ccc',
    padding: 10,
    marginBottom: 12,
  },
  // Compact Filter Controls (no box, just bottom border)
  filterGroupCompact: {
    marginHorizontal: 10,
    paddingTop: 8,
    borderBottomWidth: 1,
    borderBottomColor: '#ccc',
    marginBottom: 2,
  },
  filterRow: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    marginBottom: 10,
  },
  filterItem: {
    width: '48%',
  },
  segmentedControl: {
    flexDirection: 'row',
    justifyContent: 'center',
    marginBottom: 15,
    borderWidth: 1,
    borderColor: '#007AFF',
    borderRadius: 8,
    overflow: 'hidden',
  },
  segmentedButton: {
    flex: 1,
    paddingVertical: 10,
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#fff',
  },
  segmentedButtonActive: {
    backgroundColor: '#007AFF',
  },
  segmentedButtonText: {
    fontSize: 14,
    color: '#007AFF',
  },
  segmentedButtonTextActive: {
    color: '#fff',
    fontWeight: 'bold',
  },
  // Autocomplete
  autocompleteContainer: {
    flex: 1,
  },
  autocompleteInput: {
    padding: 0,
    fontSize: 16,
    backgroundColor: 'transparent',
    height: 40,
  },
  autocompleteInputContainer: {
    borderWidth: 1,
    borderColor: '#ccc',
    borderRadius: 5,
    paddingLeft: 6,
    backgroundColor: '#fff',
    height: 40,
  },
  autocompleteList: {
    position: 'absolute',
    top: 40,
    left: 0,
    right: 0,
    backgroundColor: '#fff',
    borderWidth: 1,
    borderColor: '#ccc',
    borderRadius: 5,
    maxHeight: 300,
    zIndex: 3000,
  },
  autocompleteItem: {
    padding: 10,
    borderBottomWidth: 1,
    borderBottomColor: '#eee',
  },
  autocompleteText: {
    fontSize: 16,
  },
  // Misc
  spinnerOverlay: {
    ...StyleSheet.absoluteFillObject,
    justifyContent: 'center',
    alignItems: 'center',
    zIndex: 10,
  },
  filterContainer: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    backgroundColor: '#fff',
    zIndex: 1000,
    paddingHorizontal: 10,
    paddingTop: 10,
  },
  viFilterContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 10,
    columnGap: 8,
  },
  filterLabel: {
    fontSize: 16,
    color: '#333',
    textAlign: 'left',
    flex: 1,
  },
  headerContainer: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  headerText: {
    fontSize: 17,
    fontWeight: '600',
  },
  headerCode: {
    fontWeight: 'normal',
  },
  filterTitle: {
    fontSize: 18,
    fontWeight: 'bold',
    marginBottom: 10,
    textAlign: 'center',
  },
  listHeader: {
    flexDirection: 'row',
    paddingBottom: 10,
    borderBottomWidth: 2,
    borderBottomColor: '#ccc',
    alignItems: 'center',
    marginBottom: 5,
    paddingHorizontal: 10,
  },
  enoHeaderContainer: {
    minWidth: 70,
    paddingRight: 15,
    justifyContent: 'center',
    alignItems: 'center',
  },
  voterInfoHeaderContainer: {
    flex: 1,
  },
  headerLabel: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#333',
  },
  modalContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: 'rgba(0,0,0,0.5)',
    zIndex: 9999,
  },
  modalView: {
    width: '90%',
    backgroundColor: 'white',
    borderRadius: 15,
    padding: 25,
    alignItems: 'stretch',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 5 },
    shadowOpacity: 0.3,
    shadowRadius: 10,
    elevation: 10,
    maxWidth: 600,
    maxHeight: '90%', // Ensure modal doesn't exceed screen height
    zIndex: 10000,
  },
  modalCloseButton: {
    position: 'absolute',
    top: 10,
    right: 10,
    zIndex: 1,
    width: 32,
    height: 32,
    borderRadius: 16,
    backgroundColor: 'transparent',
    alignItems: 'center',
    justifyContent: 'center',
  },
  modalTitle: {
    fontSize: 24,
    fontWeight: 'bold',
    marginBottom: 25,
    textAlign: 'center',
    color: '#333',
  },
  detailRow: {
    flexDirection: 'row',
    alignItems: 'center',
    marginBottom: 20,
  },
  detailLabel: {
    fontSize: 14,
    color: '#888',
    marginBottom: 2,
  },
  voterNumberValue: {
    fontSize: 28,
    fontWeight: 'bold',
    color: '#333',
  },
  detailValue: {
    fontSize: 16,
    color: '#333',
    flexWrap: 'wrap',
  },
  separator: {
    height: 1,
    backgroundColor: '#eee',
    marginVertical: 20,
  },
  checkboxContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: 10,
    marginBottom: 20,
  },
  checkboxLabel: {
    marginLeft: 12,
    fontSize: 18,
    fontWeight: '500',
  },
  voterItem: {
    flexDirection: 'row',
    padding: 10,
    borderBottomWidth: 1,
    borderBottomColor: '#eee',
    alignItems: 'center',
  },
  enoContainer: {
    minWidth: 150,
    paddingRight: 15,
    justifyContent: 'center',
    alignItems: 'center',
  },
  enoText: {
    fontSize: 24,
    fontWeight: 'bold',
    color: '#333',
    alignSelf: 'flex-start',
  },
  voterInfoContainer: {
    flex: 1,
    marginBottom: 5,
    paddingHorizontal: 10,
  },
  voterText: {
    fontSize: 16,
    marginBottom: 2,
  },
  addressText: {
    fontSize: 14,
    color: '#666',
  },
  listItemLeftAligned: {
    padding: 16,
    borderBottomWidth: 1,
    borderRadius: 6,
    margin: 10,
    flexDirection: 'row',
    alignItems: 'flex-start',
  },
  selectedItem: {
    backgroundColor: '#cce5ff',
  },
  // Battle Plan and Engagement styles
  voterCount: {
    fontSize: 12,
    color: '#666',
    fontWeight: '500',
  },
  filtersContainer: {
    backgroundColor: '#fff',
    padding: 16,
    borderBottomWidth: 1,
    borderBottomColor: '#eee',
  },
  filterInput: {
    borderWidth: 1,
    borderColor: '#ccc',
    borderRadius: 5,
    padding: 8,
    fontSize: 16,
    backgroundColor: '#fff',
    height: 40,
    flex: 1,
    marginRight: 8,
  },
  autocompleteListContainer: {
    position: 'absolute',
    top: 40,
    left: 0,
    right: 0,
    backgroundColor: '#fff',
    borderWidth: 1,
    borderColor: '#ccc',
    borderRadius: 5,
    maxHeight: 200,
    zIndex: 1000,
  },
  filterButtonContainer: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    gap: 8,
  },
  filterButton: {
    paddingHorizontal: 12,
    paddingVertical: 6,
    borderRadius: 16,
    borderWidth: 1,
    borderColor: '#ccc',
    backgroundColor: '#fff',
  },
  filterButtonActive: {
    backgroundColor: '#007AFF',
    borderColor: '#007AFF',
  },
  filterButtonText: {
    fontSize: 14,
    color: '#666',
  },
  filterButtonTextActive: {
    color: '#fff',
    fontWeight: '500',
  },
  switchContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    paddingVertical: 8,
  },
  emptyContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: 40,
  },
  noDataText: {
    color: '#6c757d',
    textAlign: 'center',
    paddingVertical: 20,
    fontStyle: 'italic',
  },
  // Engagement styles (used in campaign dashboard)
  engagementItem: {
    borderRadius: 8,
    margin: 8,
    padding: 16,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
  },
  cardSection: {
    marginBottom: 32,
  },
  // Card styles (used in campaign dashboard)
  card: {
    borderRadius: 12,
    padding: 20,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 2 },
    shadowOpacity: 0.1,
    shadowRadius: 4,
    elevation: 3,
  },
  // Engagement info styles (used in canvassing info page)
  engagementName: {
    fontSize: 16,
    fontWeight: '600',
    marginBottom: 4,
  },
  engagementType: {
    fontSize: 14,
    marginBottom: 2,
  },
  engagementStats: {
    fontSize: 12,
    marginBottom: 4,
  },
  campaignerList: {
    marginTop: 8,
  },
  campaignerItem: {
    fontSize: 12,
    color: '#888',
    marginBottom: 2,
  },

  // Address card status styles
  addressHeaderRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    marginBottom: 10,
  },
  statusIndicator: {
    flexDirection: 'row',
    alignItems: 'center',
    marginLeft: 12,
    flexShrink: 0,
  },
  statusIcon: {
    width: 24,
    height: 24,
    borderRadius: 12,
    alignItems: 'center',
    justifyContent: 'center',
    marginRight: 6,
  },
  statusText: {
    fontSize: 12,
    fontWeight: '600',
  },

  // Household screen styles
  voterVISelectionRow: {
    backgroundColor: '#f8f9fa',
    padding: 12,
    marginBottom: 15,
    borderRadius: 8,
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 2,
    elevation: 1,
    marginHorizontal: 16,
    borderWidth: 1,
    borderColor: '#e9ecef',
  },
  nameViRow: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    marginBottom: 8,
    gap: 12,
    flexWrap: 'wrap',
  },
  voterVISelectionName: {
    fontSize: 16,
    fontWeight: '600',
    color: '#333',
    flex: 1,
  },
  viPickerContainer: {
    width: 80,
    zIndex: 1000,
  },
  viPickerOutline: {
    borderWidth: 1,
    borderColor: '#ddd',
    borderRadius: 6,
    backgroundColor: '#fff',
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.05,
    shadowRadius: 2,
    elevation: 1,
    zIndex: 1001,
  },
  viTextInput: {
    padding: 8,
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: 36,
  },
  viTextInputText: {
    fontSize: 14,
    fontWeight: '600',
    color: '#333',
  },
  viDropdownItem: {
    paddingVertical: 12,
    paddingHorizontal: 16,
  },
  viDropdownItemRow: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  viColorIndicator: {
    width: 16,
    height: 16,
    borderRadius: 3,
    marginRight: 12,
    // Ensure the color box is visible
    shadowColor: '#000',
    shadowOffset: { width: 0, height: 1 },
    shadowOpacity: 0.1,
    shadowRadius: 1,
    elevation: 1,
  },
  viDropdownItemCode: {
    fontSize: 16,
    fontWeight: 'bold',
    color: '#333',
    width: 30,
    marginRight: 12,
  },
  // Additional household screen styles
  householdContainer: {
    flex: 1,
    backgroundColor: '#ffffff',
  },
  householdScrollView: {
    flex: 1,
    paddingTop: 8,
  },
  householdButtonContainer: {
    padding: 16,
    paddingBottom: 8,
  },
  householdCloseButtonContainer: {
    padding: 16,
    paddingTop: 8,
  },

  // Phone Number Input Styles
  phoneNumberContainer: {
    width: '100%',
    marginBottom: 12,
  },
  phoneNumberRow: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
  },
  countryCodeContainer: {
    minWidth: 80,
  },
  countryCodePicker: {
    borderWidth: 1,
    borderColor: '#ccc',
    borderRadius: 5,
    backgroundColor: '#fff',
    height: 40,
    justifyContent: 'center',
  },
  countryCodePickerInput: {
    height: 56,
    fontSize: 16,
    width: 100,
    borderWidth: 0,
    backgroundColor: 'transparent',
  },
  phoneNumberInputContainer: {
    flex: 1,
  },
  phoneNumberInput: {
    borderWidth: 1,
    borderColor: '#ccc',
    borderRadius: 5,
    padding: 8,
    fontSize: 16,
    backgroundColor: '#fff',
    height: 40,
    width: '100%',
  },
  phoneNumberInputError: {
    borderColor: 'red',
  },
  phoneNumberErrorText: {
    color: 'red',
    fontSize: 12,
    marginTop: 4,
    marginLeft: 4,
  },
  // Street accordion styles
  streetHeader: {
    backgroundColor: '#ffffff',
    borderBottomWidth: 1,
    borderBottomColor: '#e9ecef',
    paddingVertical: 10,
    paddingHorizontal: 12,
    marginHorizontal: 8,
    marginTop: 6,
  },
  streetHeaderContent: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    justifyContent: 'space-between',
    gap: 6,
  },
  streetHeaderLeft: {
    flexDirection: 'row',
    alignItems: 'flex-start',
    flex: 1,
  },
  streetHeaderTitle: {
    fontSize: 16,
    fontWeight: '600',
    color: '#333',
    marginLeft: 8,
    flexWrap: 'wrap',
    flexDirection: 'row',
    maxWidth: '100%',
  },
  streetHeaderStats: {
    flexDirection: 'row',
    alignItems: 'center',
    gap: 8,
    flexShrink: 0,
    minWidth: 80,
  },
  streetHeaderCount: {
    fontSize: 14,
    color: '#666',
    fontWeight: '500',
  },
  streetHeaderNotIn: {
    fontSize: 12,
    color: '#e74c3c',
    backgroundColor: '#fdf2f2',
    paddingHorizontal: 6,
    paddingVertical: 2,
    borderRadius: 4,
  },
  streetAddressesContainer: {
    paddingHorizontal: 8,
    paddingBottom: 6,
  },
  // Street progress visualization styles
  streetHeaderTitleCompleted: {
    textDecorationLine: 'line-through',
    color: '#6c757d',
  },
  streetHeaderCountCompleted: {
    color: '#6c757d',
    fontWeight: '600',
  },
  streetProgressContainer: {
    marginTop: 8,
    marginHorizontal: 4,
  },
  streetProgressBackground: {
    height: 4,
    borderRadius: 2,
    overflow: 'hidden',
  },
  streetProgressVisited: {
    height: '100%',
    borderRadius: 2,
    position: 'absolute',
    left: 0,
    top: 0,
  },
  streetProgressNotIn: {
    height: '100%',
    borderRadius: 2,
    position: 'absolute',
    top: 0,
  },

  // Standardized Progress Bar Styles
  // Usage: Use these styles for consistent progress bars across the app
  // - progressBarContainer: Container with standard margins
  // - progressBarBackground: Standard 8px height progress bar background
  // - progressBarSegment: Individual progress segments
  // - progressBarThin: 4px height for compact displays
  // - progressBarThick: 12px height for prominent displays
  progressBarContainer: {
    marginTop: 8,
    marginHorizontal: 4,
  },
  progressBarBackground: {
    height: 8,
    borderRadius: 4,
    overflow: 'hidden',
    flexDirection: 'row',
  },
  progressBarSegment: {
    height: '100%',
    borderRadius: 4,
  },
  progressBarThin: {
    height: 4,
    borderRadius: 2,
    overflow: 'hidden',
    flexDirection: 'row',
  },
  progressBarThinSegment: {
    height: '100%',
    borderRadius: 2,
  },
  progressBarThick: {
    height: 12,
    borderRadius: 6,
    overflow: 'hidden',
    flexDirection: 'row',
  },
  progressBarThickSegment: {
    height: '100%',
    borderRadius: 6,
  },

});

export default AppStyles;
